module.exports = __webpack_public_path__ + "media/newstyle/images/happy-man-using-his-tablet-home-couch_1-1addfa4fcb07134c4d923553a70e48da.png";